// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    link: {
        href: "https://monday.com/trustcenter",
        target: "_self"
    },
    linktext: "Explore our Trust Center",
    text: "Keep your company's data secure and compliant with industry-leading security standards and certifications.",
    title: "Enterprise-grade security"
};
